var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mode-theme-settings" }, [
    _c("div", { staticClass: "toggleWrapper" }, [
      _c("input", {
        staticClass: "dn",
        attrs: { type: "checkbox", id: "dn" },
        on: {
          click: function($event) {
            return _vm.switchMode()
          }
        }
      }),
      _vm._m(0)
    ]),
    _c("div", { staticClass: "mode-theme-settings__white-label" }, [
      _c(
        "label",
        { staticClass: "theme-switch__label", attrs: { for: "brand-select" } },
        [_vm._v("White-label: ")]
      ),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.dealershipGroupId,
              expression: "dealershipGroupId"
            }
          ],
          attrs: { id: "brand-select" },
          on: {
            change: [
              function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.dealershipGroupId = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              function($event) {
                return _vm.switchBrand()
              }
            ]
          }
        },
        [
          _c("option", { attrs: { value: "", selected: "" } }, [
            _vm._v("Dealership Group...")
          ]),
          _vm._l(_vm.brandingArray, function(dealershipGroup) {
            return _c(
              "option",
              {
                key: dealershipGroup.id,
                domProps: { value: dealershipGroup.id }
              },
              [_vm._v(_vm._s(dealershipGroup.name))]
            )
          })
        ],
        2
      ),
      _vm.companies
        ? _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.companyId,
                  expression: "companyId"
                }
              ],
              attrs: { id: "company-select" },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.companyId = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  function($event) {
                    return _vm.switchCompany()
                  }
                ]
              }
            },
            [
              _c("option", { attrs: { value: "0", selected: "" } }, [
                _vm._v("Company...")
              ]),
              _vm._l(_vm.companies, function(company) {
                return _c(
                  "option",
                  { key: company.id, domProps: { value: company.id } },
                  [_vm._v(_vm._s(company.name))]
                )
              })
            ],
            2
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "toggle", attrs: { for: "dn" } }, [
      _c("span", { staticClass: "toggle__handler" }, [
        _c("span", { staticClass: "crater crater--1" }),
        _c("span", { staticClass: "crater crater--2" }),
        _c("span", { staticClass: "crater crater--3" })
      ]),
      _c("span", { staticClass: "star star--1" }),
      _c("span", { staticClass: "star star--2" }),
      _c("span", { staticClass: "star star--3" }),
      _c("span", { staticClass: "star star--4" }),
      _c("span", { staticClass: "star star--5" }),
      _c("span", { staticClass: "star star--6" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }